import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const deploymentPlugin = createPlugin({
  id: 'deployment',
  routes: {
    root: rootRouteRef,
  },
});

/** Standalone page for deployment management (mount at /deployments). */
export const DeploymentPage = deploymentPlugin.provide(
  createRoutableExtension({
    name: 'DeploymentPage',
    component: () =>
      import('./components/DeploymentPage').then(m => m.DeploymentPage),
    mountPoint: rootRouteRef,
  }),
);

/** Entity page content for the "Deployments" tab. */
export const EntityDeploymentContent = deploymentPlugin.provide(
  createRoutableExtension({
    name: 'EntityDeploymentContent',
    component: () =>
      import('./components/EntityDeploymentContent').then(
        m => m.EntityDeploymentContent,
      ),
    mountPoint: rootRouteRef,
  }),
);
